import { RadioField, useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { ADD_TO_EXISTING_ACTION, CREATE_AND_ADD_ACTION } from './constants';
import { GroupSelect } from './group_select';
import { hasUserGroupsSelector } from './selectors';
import { TextFieldWithCounter } from '../../components/core/form';
const wrapperOffsetLeftCss = "w1o3glkt";
const wrapperCss = "wpob5up";
const Wrapper = forwardRef((props, ref) => {
  const {
    offsetLeft,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperOffsetLeftCss]: offsetLeft
  }, props.className)} />;
});
const containerGap4Css = "c1lblgwo";
const containerGap8Css = "c18x0wy5";
const containerGap16Css = "c1javxmd";
const containerGap24Css = "c1iebyz";
const containerCss = "c1lm0uc5";
const Container = forwardRef((props, ref) => {
  const {
    gap,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerGap4Css]: gap?.toString() === '4',
    [containerGap8Css]: gap?.toString() === '8',
    [containerGap16Css]: gap?.toString() === '16',
    [containerGap24Css]: gap?.toString() === '24'
  }, props.className)} />;
});
export const FormContent = ({
  subtitle
}) => {
  const hasUserGroups = useSelector(hasUserGroupsSelector);
  const {
    setFieldValue
  } = useFormContext();
  const selectExisting = () => setFieldValue('action', ADD_TO_EXISTING_ACTION);
  const selectCreate = () => setFieldValue('action', CREATE_AND_ADD_ACTION);
  return <Container gap={24}>
      <Container gap={8}>
        {subtitle && <BodyText weight="bold">
            {subtitle}
          </BodyText>}
        <BodyText>
          {I18n.t('publisher.organization.members.add_to_group.membership_switch_information')}
        </BodyText>
      </Container>
      <Container gap={16}>
        {hasUserGroups && <Container gap={4}>
            <RadioField label={<BodyText size="medium" weight="bold" inline>
                  {I18n.t('publisher.organization.members.add_to_group.add_to_existing')}
                </BodyText>} name="action" value={ADD_TO_EXISTING_ACTION} />
            <Wrapper offsetLeft={hasUserGroups}>
              <GroupSelect onFocus={selectExisting} />
            </Wrapper>
          </Container>}
        <Container gap={4}>
          {hasUserGroups ? <RadioField label={<BodyText size="medium" weight="bold" inline>
                  {I18n.t('publisher.organization.members.add_to_group.add_to_new')}
                </BodyText>} id="create-group-option" name="action" value={CREATE_AND_ADD_ACTION} /> : <label htmlFor="group-name">
              <BodyText inline weight="bold">
                {I18n.t('publisher.organization.members.add_to_group.add_to_new')}
              </BodyText>
            </label>}
          <Wrapper offsetLeft={hasUserGroups}>
            <TextFieldWithCounter id="group-name" name="name" placeholder={I18n.t('publisher.organization.members.add_to_group.group_name_placeholder')} lengthError={I18n.t('publisher.organization.user_groups.form.counter_validation_error')} aria-labelledby={hasUserGroups ? 'create-group-option' : null} maxLength={50} onFocus={selectCreate} />
          </Wrapper>
        </Container>
      </Container>
    </Container>;
};

require("./form_content.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_content.js");